import { SearchFilterOption } from "../../../shared/components/search-bar/search-filter/search-filter.component";
import { SearchInputOption } from "../../../shared/components/search-bar/search-input/search-input.component";
import { UserInfo } from "../../../shared/types/user-info";
import { CompanyService } from "../companies/company.service";
import { PartnerService } from "../partners/partner.service";
import { Contract } from "./contract.type";

//#region Search Filter Options

export const getContractSearchFilterOptions = (
  user: UserInfo,
  config?: {
    shown?: string[];
    hidden?: string[];
    partnerService?: PartnerService;
    companyService?: CompanyService;
  },
): SearchFilterOption<Contract>[] => {
  const { shown, hidden, partnerService, companyService } = config || {};

  return (
    [
      { value: "name", label: "Name" },
      {
        value: "number",
        label: "Contract #",
        filterByFunction: (value: string) => {
          const [number, version] = value?.toString().split("-") || [];
          return { ...(number && { number: { $cont: number } }), ...(version && { version: { $cont: version } }) };
        },
      },
      {
        auxValue: "partnerId",
        value: "company.partner.name",
        label: "Partner",
        hidden: !user.isGlobal() || !partnerService,
        filterByProperty: { company: { partner: { name: true } } },
      },
      {
        id: "company.name",
        auxValue: "companyId",
        value: "company.name",
        label: "Company",
        filterByProperty: { company: { name: true } },
        hidden: user.isCompanyOrViewAsCompany({ ignoreIfMultiCompanies: true }) || !companyService,
      },
      {
        value: "reseller",
        label: "Reseller",
        hidden:
          user.isCompanyOrViewAsCompany() || (user.isPartnerOrViewAsPartner() && !user?.partner?.isResellerNeeded),
      },
      {
        value: "endDate",
        label: "End Date",
        inputType: "dropdown",
        options: [...contractEndDates],
      },
      {
        value: "status",
        label: "Status",
        inputType: "dropdown",
        options: [...contractStatuses],
      },
    ] as SearchFilterOption<Contract>[]
  ).filter((opt) => (shown ? shown.includes(opt.value) : true) && (hidden ? !hidden.includes(opt.value) : true));
};

//#endregion

//#region Search Input Options

export const contractStatuses: SearchInputOption[] = [
  { value: "pending", label: "Pending" },
  { value: "active", label: "Active" },
  { value: "terminated", label: "Terminated" },
  { value: "expired", label: "Expired" },
];

export const contractTypes: SearchInputOption[] = [
  { value: "oem", label: "OEM" },
  { value: "third party", label: "Third Party" },
  { value: "warranty", label: "Warranty" },
  { value: "software", label: "Software" },
];

export const contractEndDates: SearchInputOption[] = [
  { value: "expired", label: "Expired" },
  { value: "now", label: "Now" },
  { value: "thirtyPlus", label: "+30 days" },
  { value: "ninetyPlus", label: "+90 days" },
];

//#endregion
